import gql from 'graphql-tag';

export const BOX_FRAGMENT = gql`
    fragment BoxFragment on Box {
        _id
        bundleId
        state
        bundle {
            _id
            number
            state
            closingDate
        }
        label
        number
        code
        deliveryCode
        type
        containerType
        volumeTaken
        weightTaken
        createdAt
        columnId
        column {
            name
            fullname
            type
        }
        products {
            _id
            product {
                externalProductId
            }
            productLabel
            quantity
            quantityPicked
            photoUrl
            unit
            boxId
            unitVolume
            unitWeight
        }
    }
`;
